<template>
  <v-container>
    <div :class="$vuetify.breakpoint.mdAndUp ? 'display-1' : 'title'">
      Assessments
    </div>

    <v-divider
      class="pb-3"
    />

    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <v-img
          class="mx-auto"
          src="@/assets/assessment/gla_cover_image.jpg"
          lazy-src="@/assets/assessment/gla_cover_image.jpg"
          aspect-ratio="1.7"
          :max-width="$vuetify.breakpoint.mdAndDown ? '600px' : ''"
        >
          <template #placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              />
            </v-row>
          </template>
        </v-img>
      </v-col>
      <v-col
        cols="12"
        md="9"
      >
        <div
          class="pb-4"
          :class="$vuetify.breakpoint.mdAndUp ? 'headline' : 'title'"
        >
          Global Leadership Assessment (GLA 360)
        </div>
        <div
          class="pb-2"
          :style="`font-size: ${customRem}px;`"
        >
          Here you will find access to the GLA360 portal
          where you can setup and launch assessments,
          send out automated reminders, and generate reports.
          The GLA360 is a 360 leadership assessment rooted in
          groundbreaking research involving CEOs of Fortune 100 companies,
          global thought leaders,
          and international business executives of organizations on 6 continents.
          It articulates and measures the top 15 most pressing competencies for
          today’s global leader. It shows leaders the areas they need to develop
          in order to succeed in a competitive business environment.
        </div>
        <v-btn
          outlined
          :block="$vuetify.breakpoint.smAndDown"
          style="text-transform: none;"
          @click="tripManager('gla')"
        >
          Go to GLA 360
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <v-img
          class="mx-auto"
          src="@/assets/assessment/coaching_tools.jpg"
          lazy-src="@/assets/assessment/coaching_tools.jpg"
          aspect-ratio="1.7"
          :max-width="$vuetify.breakpoint.mdAndDown ? '600px' : ''"
        >
          <template #placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              />
            </v-row>
          </template>
        </v-img>
      </v-col>
      <v-col
        cols="12"
        md="9"
      >
        <div
          class="pb-4"
          :class="$vuetify.breakpoint.mdAndUp ? 'headline' : 'title'"
        >
          Coaching Tools
        </div>

        <div
          class="pb-2"
          :style="`font-size: ${customRem}px;`"
        >
          Here you will find access to the Coaching Tools
          to manage your coaching engagements using Feedforward,
          Action Planning, and Pulse. Using the Coaching Tools,
          you get better measurable results and spend less time.
          It reduces your session prep and follow-ups to just 15 minutes
          while delivering Triple Win Leadership Coaching that improves leaders,
          their teams and business performances with 95% coworker satisfaction rate.
          And as a coach, you'll experience your Triple Win:
          More Impact, More Coaching, More Clients.
        </div>
        <v-btn
          outlined
          :block="$vuetify.breakpoint.smAndDown"
          style="text-transform: none;"
          @click="tripManager('coaching_tools')"
        >
          Go to Coaching Tools
        </v-btn>
      </v-col>
    </v-row>

    <!--    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <v-img
          class="mx-auto"
          src="@/assets/assessment/lgpr_cover_image.jpg"
          lazy-src="@/assets/assessment/lgpr_cover_image.jpg"
          aspect-ratio="1.7"
          :max-width="$vuetify.breakpoint.mdAndDown ? '600px' : ''"
        >
          <template #placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              />
            </v-row>
          </template>
        </v-img>
      </v-col>
      &lt;!&ndash;      <v-col
        cols="12"
        md="9"
      >
        <div
          class="pb-4"
          :class="$vuetify.breakpoint.mdAndUp ? 'headline' : 'title'"
        >
          Leadership Growth Progress Review (LGPR mini-survey)
        </div>

        <div
          class="pb-2"
          :style="`font-size: ${customRem}px;`"
        >
          The LGPR has been replaced by the Pulse in the GCG Coaching Tools above.
          You can complete the data collection for LGPRs you have launched until end Aug 2024.
          To start using the newest GCG Coaching Tools with your clients you can subscribe here:
          GCG Coaching Tools. For questions or use of specific language versions,
          email us at
          <a href="mailto:support@globalcoachgroup.com">support@globalcoachgroup.com</a>.
          &lt;!&ndash;<v-btn
            class="px-0 mt-n1"
            color="primary"
            :style="`
            text-decoration: underline;
            text-transform: unset;
            font-size: ${customRem}px;
            font-weight: normal;
          `"
            text
            small
            @click="openLGPR('sccoaching.com/assessments/')"
          >
            Learn more about the LGPR
          </v-btn>&ndash;&gt;
        </div>
        <v-btn
          outlined
          :block="$vuetify.breakpoint.smAndDown"
          style="text-transform: none;"
          @click="tripManager('coaching_tools')"
        >
          Go to Coaching Tools
        </v-btn>
      </v-col>&ndash;&gt;
    </v-row>-->

    <AssessmentModal
      :dialog.sync="dialogFlag"
      :option="dialogOption"
    />
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import AssessmentModal from './widget/AssessmentModal.vue';

export default {
  name: 'Assessment',

  components: {
    AssessmentModal,
  },

  data: () => ({
    dialogFlag: false,
    dialogOption: '',
  }),

  computed: {
    ...mapState({
      user: (state) => state.account.user,
    }),

    customRem() {
      return this.$vuetify.breakpoint.mdAndUp ? '17' : '16';
    },

    userCertification() {
      const certList = [];
      if (this.user && this.user.certifications) {
        this.user.certifications.forEach((el) => {
          if (el.certification) {
            certList.push(el.certification.id);
          }
        });
      }
      return certList;
    },
  },

  methods: {
    tripManager(option) {
      if (option === 'gla') {
        if (this.userCertification.includes('gla_360')) {
          window.open(`${process.env.VUE_APP_GLA_CLIENT}`, '_blank');
        } else {
          this.dialogOption = option;
          this.dialogFlag = true;
        }
      } else if (option === 'lgpr') {
        if (this.userCertification.includes('indiv_coaching')) {
          this.openLGPR('sccoaching.com/assessments/');
        } else {
          this.dialogOption = option;
          this.dialogFlag = true;
        }
      } else if (option === 'coaching_tools') {
        if (this.user?.services?.some((service) => service.service_id === 'coach_tools')) {
          window.open(`${process.env.VUE_APP_COACH_TOOLS_CLIENT}`, '_blank');
        } else {
          this.dialogOption = option;
          this.dialogFlag = true;
        }
      }
    },

    openLink(link) {
      window.open(`https://${link}`, '_blank');
    },

    openLGPR(link) {
      const email = this.user.email || '';
      const id = this.user.contact_id || '';
      const query = `?memb_autologin=yes&auth_key=qPUj9bUJwcUJ&Id=${id}&Email=${email}&redir=/assessments/lgpr`;
      window.open(`https://${link}${query}`, '_blank');
    },
  },

};
</script>
